// extracted by mini-css-extract-plugin
export var addToCartButton = "_qr-b";
export var arrowButtonContainer = "_qr-9";
export var arrowButtonIcon = "_qr-a";
export var carouselArrowButton = "_qr-6";
export var carouselElementContainer = "_qr-1";
export var galleryThumbnail = "_qr-d";
export var galleryThumbnailImage = "_qr-e";
export var left = "_qr-7";
export var productDisplayCarouselContainer = "_qr-0";
export var productTileContainer = "_qr-2";
export var productTileImage = "_qr-4";
export var productTileImageContainer = "_qr-3";
export var productTileTitle = "_qr-5";
export var right = "_qr-8";
export var sliderOverflow = "_qr-c";